import React, { useEffect, useRef, useState, JSX } from 'react';
import { ApiImage } from '@ibe/api';
import ImageGallery, { ReactImageGalleryItem } from 'react-image-gallery';

const ImageGallerySlider = ({
  images,
  initialGalleryImageIndex,
  galleryChangeTrigger,
  renderItem,
  renderThumbInner
}: {
  images: ApiImage[];
  initialGalleryImageIndex?: number;
  galleryChangeTrigger?: boolean;
  renderItem?: (item: ReactImageGalleryItem) => React.ReactNode;
  renderThumbInner?: (item: ReactImageGalleryItem) => React.ReactNode;
}): JSX.Element => {
  const [currentImageIndex, setCurrentImageIndex] = useState<number>(0);
  const galleryRef = useRef<ImageGallery>(null);
  const initialRender = useRef<boolean>(false);

  useEffect(() => {
    if (initialGalleryImageIndex !== undefined) {
      setCurrentImageIndex(initialGalleryImageIndex);
    }
  }, [initialGalleryImageIndex]);

  useEffect(() => {
    setTimeout(() => {
      if (galleryRef.current && initialRender.current) {
        galleryRef.current.slideToIndex(currentImageIndex);
      }
      initialRender.current = true;
    }, 300);
  }, [galleryChangeTrigger]);

  return (
    <div className="iso__image-gallery__container">
      <ImageGallery
        ref={galleryRef}
        items={images.map(image => ({ original: image.url, thumbnail: image.url }))}
        renderItem={renderItem}
        renderThumbInner={renderThumbInner}
        showFullscreenButton={false}
        showPlayButton={false}
        startIndex={initialGalleryImageIndex}
        onSlide={(idx: number): void => setCurrentImageIndex(idx)}
      />
    </div>
  );
};

export default ImageGallerySlider;
